import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { IUserSessionPayload } from '@topshots/core-models';

const parseTokenPayload = (token: string) => {
  const base64Url = token.split('.')[1]; // Get the payload part
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );

  return JSON.parse(jsonPayload) as IUserSessionPayload;
};

export interface AuthState {
  token?: string;
  tokenPayload?: IUserSessionPayload;
}

const initialState: AuthState = {
  token: localStorage.getItem('AUTH_TOKEN') ?? undefined,
  tokenPayload: localStorage.getItem('AUTH_TOKEN')
    ? parseTokenPayload(localStorage.getItem('AUTH_TOKEN') ?? '')
    : undefined,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
      state.tokenPayload = parseTokenPayload(action.payload);
      localStorage.setItem('AUTH_TOKEN', action.payload);
    },
    clearToken: (state) => {
      state.token = undefined;
      logout();
    },
  },
});

export const logout = () => {
  localStorage.removeItem('AUTH_TOKEN');
  window.location.reload();
};

export const { setToken, clearToken } = authSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectToken = (state: RootState) => state.auth.token;
export const selectTokenPayload = (state: RootState) => state.auth.tokenPayload;

export default authSlice.reducer;
